<div class="menu" [ngClass]="{ opened: opened }">
  <div class="menu__controls">
    <ng-container *ngIf="!opened">
      <mfp-button
        class="menu__controls__open-button"
        size="large"
        fill="clear"
        padding="none"
        icon="assets/icons/menu.svg"
        (click)="onMenuButtonClick()"
      ></mfp-button>
    </ng-container>
    <ng-container *ngIf="opened && selectedNavigation === 'life-plan'">
      <mfp-button
        class="menu__controls__back-button"
        size="small"
        fill="clear"
        padding="none"
        icon="assets/icons/back-arrow-mobile.svg"
        (click)="onBackButtonClick()"
      ></mfp-button>
    </ng-container>
    <ng-container *ngIf="opened && window.innerWidth < 1920">
      <mfp-button
        class="menu__controls__close-button"
        size="large"
        fill="clear"
        padding="none"
        icon="assets/icons/menu-close.svg"
        (click)="onCloseButtonClick()"
      ></mfp-button>
    </ng-container>
  </div>
  <ng-container *ngIf="selectedNavigation === 'menu'">
    <div class="menu__content">
      <div class="menu__navigation-list">
        <div
          class="menu__item"
          [ngClass]="{
            'menu__item--active': checkItemsActive(['/agent/life-plans', '/agent/life-plans/:lifePlanId/form/(.*)'])
          }"
          (click)="navigateTo('/agent/life-plans')"
        >
          <div class="menu__title">
            {{ 'MENU.NAVIGATION.LIFE_PLANS' | translate }}
          </div>
        </div>
        <div
          class="menu__item"
          [ngClass]="{ 'menu__item--active': checkItemActive('/agent/commercial-guide') }"
          (click)="navigateTo('/agent/commercial-guide')"
        >
          <div class="menu__title">
            {{ 'MENU.NAVIGATION.COMMERCIAL_GUIDE' | translate }}
          </div>
        </div>
      </div>
      <ng-container>
        <div class="menu__login">
          <div class="menu__separator"></div>
          <div class="menu__divider"></div>
          <div class="menu__profile">
            <div class="profile__column">
              <div class="profile__avatar">{{ loggedUserName?.substr(0, 1) }}</div>
            </div>
            <div class="profile__column">
              <p class="profile__name">{{ loggedUserName }}</p>
              <div class="menu__link" (click)="logout()">{{ 'MENU.EXIT' | translate }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
<ng-container *ngIf="view === 'client' || selectedNavigation === 'life-plan'">
    <div class="menu__life-plan">
      <div class="menu__title menu__title--no-desktop">
        {{ 'MENU.LIFE_PLAN.TITLE' | translate: { name: 'Roberto' } }}
      </div>
      <div
        class="menu__item"
        [ngClass]="{ 'menu__item--active': checkItemActive('/:userType/life-plans/:lifePlanId/user-form') }"
        (click)="navigateTo('/:userType/life-plans/:lifePlanId/user-form')"
      >
        <div class="menu__label">
          {{ (opened ? 'MENU.LIFE_PLAN.MY_DATA.LONG_NAME' : 'MENU.LIFE_PLAN.MY_DATA.SHORT_NAME') | translate }}
        </div>
      </div>
      <div
        class="menu__item"
        [ngClass]="{
          'menu__item--active': checkItemActive('/:userType/life-plans/:lifePlanId'),
          'menu__item--disabled': currentLifePlan?.type !== 'COMPLETE'
        }"
        (click)="navigateTo('/:userType/life-plans/:lifePlanId')"
      >
        <div class="menu__label">
          {{ (opened ? 'MENU.LIFE_PLAN.LIFE_CICLE.LONG_NAME' : 'MENU.LIFE_PLAN.LIFE_CICLE.SHORT_NAME') | translate }}
        </div>
      </div>
      <div class="menu__divider"></div>
      <ng-container *ngFor="let protection of protections">
        <mfp-category-button
          class="menu__item menu__category"
          type="protection"
          [label]="(opened ? protection.longName : protection.shortName) | translate"
          [icon]="protection.icon"
          [productsAdded]="protection.productsAdded"
          [totalProducts]="protection.totalProducts"
          [healthPoints]="protection.healthPoints"
          [opened]="opened"
          [disabled]="!protection.active"
          [ngClass]="{
            'menu__item--active': checkItemActive('/:userType/life-plans/:lifePlanId/insurances/' + protection.path)
          }"
          (click)="navigateTo('/:userType/life-plans/:lifePlanId/insurances/' + protection.path)"
        ></mfp-category-button>
      </ng-container>
      <div class="menu__divider"></div>
      <mfp-category-button
        class="menu__item menu__category"
        type="cart"
        icon="assets/icons/cart-dark.svg"
        [label]="(opened ? 'MENU.LIFE_PLAN.LIFE_PLAN.LONG_NAME' : 'MENU.LIFE_PLAN.LIFE_PLAN.SHORT_NAME') | translate"
        [productsAdded]="getTotalCartProducts()"
        [totalProducts]="getTotalCartProducts()"
        [healthPoints]="getTotalFinancialHealth()"
        [opened]="opened"
        [disabled]="disabled"
        [ngClass]="{ 'menu__item--active': checkItemActive('/:userType/life-plans/:lifePlanId/summary') }"
        (click)="navigateTo('/:userType/life-plans/:lifePlanId/summary')"
      ></mfp-category-button>
    </div>
  </ng-container>
</div>
